import {
  NewModalButtonTriggerComponent,
  NewModalButtonTriggerComponentProps,
} from "./NewModalButtonTriggerComponent";
import {
  NewModalDropdownItemTriggerComponent,
  NewModalDropdownItemTriggerComponentProps,
} from "./NewModalDropdownItemTriggerComponent";

export const NewModalTriggerComponent = (props: {
  props: NewModalTriggerComponentProps;
  setOpen: any;
}) => {
  return (
    <>
      {props.props.type === "button" && (
        <NewModalButtonTriggerComponent
          props={props.props}
          setOpen={props.setOpen}
        />
      )}
      {props.props.type === "dropdown_item" && (
        <NewModalDropdownItemTriggerComponent
          props={props.props}
          setOpen={props.setOpen}
        />
      )}
    </>
  );
};

export type NewModalTriggerComponentProps =
  | NewModalButtonTriggerComponentProps
  | NewModalDropdownItemTriggerComponentProps;
